import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Navbar, Nav, NavItem } from 'react-bootstrap';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';


export const Community_Nav = () => {
    return <div className=' py-2'>
        <div className='flex flex-row justify-evenly'>
            <Link to="/home" className='text-dark pb-2 '><ArrowBackIcon /></Link>
            <Link to="/community/advertisements" className='text-dark pb-2 pb-sm-0'>Advertisements</Link>

            <Link to="/community/posts" className='text-dark pb-2'>Posts</Link>



        </div>
    </div>
}